module.exports = __webpack_public_path__ + "img/Vietnam.0e342caf.jpg";